export default __webpack_public_path__ + "d1f171ad72af5ee822a2c8528fb4c715.png";